import service from 'service';

export const getSenderNameList = ({ queryKey: [, params] }) => {
  const url = '/core_sender/v1/sender_name';
  return service.get(url, { params });
};

export const exportSenderName = ({ queryKey: [, params] }) => {
  const url = '/core_sender/v1/report/export';
  return service.get(url, { params });
};

export const getSmsUsageList = ({ queryKey: [, params] }) => {
  const url = '/core_messaging/v1/report';
  return service.get(url, { params });
};

export const exportSmsUsage = ({ queryKey: [, params] }) => {
  const url = '/core_messaging/v1/report/export';
  return service.get(url, { params });
};

export const getTransactionList = ({ queryKey: [, params] }) => {
  const url = '/core_wallet/v1/report/ledger';
  return service.get(url, { params });
};

export const exportTransaction = ({ queryKey: [, params] }) => {
  const url = '/core_wallet/v1/report/ledger/export';
  return service.get(url, { params });
};

export const getBalanceList = ({ queryKey: [, params] }) => {
  const url = '/core_wallet/v1/report/wallet';
  return service.get(url, { params });
};

export const exportBalance = ({ queryKey: [, params] }) => {
  const url = '/core_wallet/v1/report/wallet/export';
  return service.get(url, { params });
};

export const getRegistrationList = ({ queryKey: [, params] }) => {
  const url = '/core_subscriber/report/organization';
  return service.get(url, { params });
};

export const exportRegistration = ({ queryKey: [, params] }) => {
  const url = '/core_subscriber/report/organization/export';
  return service.get(url, { params });
};

export const getClientList = ({ queryKey: [, params] }) => {
  const url = '/core_subscriber/report/user';
  return service.get(url, { params });
};

export const exportClient = ({ queryKey: [, params] }) => {
  const url = '/core_subscriber/report/user/export';
  return service.get(url, { params });
};
